// material-ui
import { useTheme } from "@mui/material/styles";
import { Box, CardMedia, Container, Grid, Typography } from "@mui/material";

// third party
import { motion } from "framer-motion";

// project import
import useConfig from "../../hooks/useConfig";

// types
import { ThemeMode } from "../../types/config";

// assets
import { CheckCircleOutlined } from "@ant-design/icons";
// import imgelementmsg from "../../assets/images/landing/img-element-msg.png";
// import imgelementwidget from "../../assets/images/landing/img-element-widget.png";
import imgelementmain from "../../assets/images/landing/bemsign-main-phone.png";

// ==============================|| LANDING - ELEMENT PAGE ||============================== //

const ElementBlock = () => {
  const theme = useTheme();
  const { presetColor } = useConfig();

  const checkIcon = (
    //@ts-ignore
    <CheckCircleOutlined
      style={{ color: theme.palette.primary.main, fontSize: "1.15rem" }}
    />
  );

  return (
    <Box
      sx={{
        overflowX: "hidden",
        position: "relative",
        "&:after": {
          content: '""',
          position: "absolute",
          width: "100%",
          height: "45%",
          bottom: 0,
          left: 0,
          background:
            theme.palette.mode === ThemeMode.DARK
              ? theme.palette.grey[100]
              : theme.palette.secondary[800],
          [theme.breakpoints.down("sm")]: { height: "60%" },
        },
        "@keyframes slideY": {
          "0%": {
            transform: "translateY(0px)",
          },
          "50%": {
            transform: "translateY(0px)",
          },
          "100%": {
            transform: "translateY(0px)",
          },
          "25%": {
            transform: "translateY(-20px)",
          },
          "75%": {
            transform: "translateY(20px)",
          },
        },
      }}
    >
      <Container sx={{ position: "relative", zIndex: 1 }}>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          spacing={2}
          sx={{ mt: { md: 15, xs: 2.5 }, mb: { md: 10, xs: 2.5 } }}
        >
          <Grid item xs={12}>
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ mb: 4, textAlign: "center" }}
            >
              <Grid item sm={10} md={6}>
                <Grid container spacing={1} justifyContent="center">
                  <Grid item xs={12}>
                    <Typography variant="h2">
                      Está pronto para transformar a maneira como você autentica
                      e assina eletronicamente?
                      {/* <Box component="span" sx={{ display: "block" }}>
                        <Box
                          component="span"
                          sx={{ mr: 1, color: theme.palette.primary.main }}
                        >
                          web apps
                        </Box>
                        with Mantis React
                      </Box> */}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      No mundo digital de hoje, a segurança é primordial. Com o
                      Bemsign, você tem uma solução robusta que protege, valida
                      e autentica cada interação. Entre em contato conosco e
                      descubra como podemos revolucionar seus processos de
                      autenticação e assinatura.
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={9}>
            <Box sx={{ position: "relative", mb: 3 }}>
              <div
              // initial={{ opacity: 0, scale: 0 }}
              // animate={{ opacity: 1, scale: 1 }}
              // transition={{
              //   type: "spring",
              //   stiffness: 150,
              //   damping: 30,
              //   delay: 0.4,
              // }}
              >
                <CardMedia
                  component="img"
                  image={imgelementmain}
                  sx={{ width: "100%", m: "0 auto" }}
                />
              </div>
              {/* <Box
                sx={{
                  width: "auto",
                  position: "absolute",
                  top: "3%",
                  right: "-17%",
                  animation: "10s slideY linear infinite",
                  animationDelay: "2s",
                  [theme.breakpoints.down("sm")]: { display: "none" },
                }}
              >
                <div
                //   initial={{ opacity: 0, scale: 0 }}
                //   animate={{ opacity: 1, scale: 1 }}
                //   transition={{
                //     type: "spring",
                //     stiffness: 150,
                //     damping: 30,
                //     delay: 0.4,
                //   }}
                >
                  <CardMedia
                    component="img"
                    image={imgelementmsg}
                    sx={{
                      width: "auto",
                      position: "absolute",
                      top: "3%",
                      right: "-17%",
                      [theme.breakpoints.down("sm")]: { display: "none" },
                    }}
                  />
                </div>
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  bottom: "20%",
                  left: "-17%",
                  width: "auto",
                  animation: "10s slideY linear infinite",
                  animationDelay: "2s",
                  [theme.breakpoints.down("sm")]: { display: "none" },
                }}
              >
                <div
                //   initial={{ opacity: 0, scale: 0 }}
                //   animate={{ opacity: 1, scale: 1 }}
                //   transition={{
                //     type: "spring",
                //     stiffness: 150,
                //     damping: 30,
                //     delay: 0.4,
                //   }}
                >
                  <CardMedia
                    component="img"
                    image={imgelementwidget}
                    sx={{
                      width: "auto",
                      position: "absolute",
                      bottom: "20%",
                      left: "-17%",
                      [theme.breakpoints.down("sm")]: { display: "none" },
                    }}
                  />
                </div>
              </Box> */}
            </Box>
          </Grid>
          {/* <Grid item xs={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Grid container spacing={1}>
                  <Grid item>{checkIcon}</Grid>
                  <Grid item xs zeroMinWidth>
                    <Typography variant="body1" color="#8c8c8c">
                      Auth Methods : JWT, Auth0, Firebase
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Grid container spacing={1}>
                  <Grid item>{checkIcon}</Grid>
                  <Grid item xs zeroMinWidth>
                    <Typography variant="body1" color="#8c8c8c">
                      Internationalization Support
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Grid container spacing={1}>
                  <Grid item>{checkIcon}</Grid>
                  <Grid item xs zeroMinWidth>
                    <Typography variant="body1" color="#8c8c8c">
                      Mock API
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Grid container spacing={1}>
                  <Grid item>{checkIcon}</Grid>
                  <Grid item xs zeroMinWidth>
                    <Typography variant="body1" color="#8c8c8c">
                      Code Splitting
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Grid container spacing={1}>
                  <Grid item>{checkIcon}</Grid>
                  <Grid item xs zeroMinWidth>
                    <Typography variant="body1" color="#8c8c8c">
                      React Hooks
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Grid container spacing={1}>
                  <Grid item>{checkIcon}</Grid>
                  <Grid item xs zeroMinWidth>
                    <Typography variant="body1" color="#8c8c8c">
                      Google Fonts
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Grid container spacing={1}>
                  <Grid item>{checkIcon}</Grid>
                  <Grid item xs zeroMinWidth>
                    <Typography variant="body1" color="#8c8c8c">
                      RTL Support
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Grid container spacing={1}>
                  <Grid item>{checkIcon}</Grid>
                  <Grid item xs zeroMinWidth>
                    <Typography variant="body1" color="#8c8c8c">
                      Light/Dark, Semi Dark Support
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Grid container spacing={1}>
                  <Grid item>{checkIcon}</Grid>
                  <Grid item xs zeroMinWidth>
                    <Typography variant="body1" color="#8c8c8c">
                      Prettier Code Style
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid> */}
        </Grid>
      </Container>
    </Box>
  );
};

export default ElementBlock;
